module.exports = __webpack_public_path__ + "06_mid_brown.5f0d7712.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/06_mid_brown.png
// module id = 7pgd
// module chunks = 0